import request from '@/utils/request'

// 查询H5页面列表
export async function listKHttpCode (query) {
    return request({
        url: '/system/kHttpCode/list',
        method: 'get',
        params: query
    })
}

export async function getDatabaseIsExits (params) {
    // http://localhost:8081/prod-api/system/productlabelimage/list?qrurl=http://cx.panpass.com/?fw=6082032761459599
    return request({
        url: '/system/productlabelimage/list',
        method: 'get',
        params
    })
}

export function getDict (dictValue) {
    // http://localhost:8081/prod-api/system/productlabelimage/list?qrurl=http://cx.panpass.com/?fw=6082032761459599
    return request({
        url: '/system/dict/data/quotationConfig',
        method: 'get',
        params: { dictCode: dictValue }
    })
}

export function getDict2 (dictValue) {
    // http://localhost:8081/prod-api/system/productlabelimage/list?qrurl=http://cx.panpass.com/?fw=6082032761459599
    return request({
        url: '/system/dict/data/list',
        method: 'get',
        params: { dictType: dictValue }
    })
}


// WEBPACK FOOTER //
// ./src/api/kHttpCode.js